import { createSignal, Show, For } from 'solid-js';
import { Action, EventType } from './../../types/constants';
import { ActionCTA } from './ActionCTA';
import { eventTrackerStore } from '@/utils/event-tracker-store';

type ActionsProps = {
  actions: Action[] | undefined;
  apiHost: string;
  apiKey: string;
};

export const Actions = (props: ActionsProps) => {
  const [actions] = createSignal(props.actions || []);
  const [eventTracker] = eventTrackerStore;
  if (!actions().length) {
    return null;
  }

  const trackAction = async (action: Action) => {
    await eventTracker?.track({
      name: action.label,
      type: EventType.SearchWidgetAction,
      data: {},
    });
  };

  return (
    <div class="flex flex-col gap-4 w-full">
      <For each={actions()}>
        {(action) => (
          <Show when={action}>
            <ActionCTA
              action={action}
              onClick={() => trackAction(action)}
              className="p-3 bfsearch-container text-[var(--bfsearch-text-base-color)]"
            />
          </Show>
        )}
      </For>
    </div>
  );
};
